/*
 * @Author: dali
 * @Date: 2022-07-07 16:11:45
 * @LastEditors: 陈威达 aser0827@163.com
 * @LastEditTime: 2025-08-01 13:36:54
 * @FilePath: \gerlun-react-website\src\components\forgetPassword\index.jsx
 * @Description:
 */
import { Button, Form, Input, Space, message } from 'antd'
import React, { useState, Fragment, useImperativeHandle } from 'react'
import { Modal } from 'antd'
import User from '@/modules/user'

import styles from './forget.scss'
import ForgetForm from './forgetForm'

const ForgetPassword = (props) => {
  const user = new User()
  // 属性
  const [findModalVisible, handleModalVisible] = useState(false)

  const forgetFormRef = React.createRef()

  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })
  const open = () => {
    handleModalVisible(true)
  }

  const checkPhoneValue = async(value)=>{
    if (['', undefined].includes(value)) {
      return Promise.reject(new Error('请输入手机号!'))
    }
    if (value && value.length !== 11) {
      return Promise.reject(new Error('请输入11位的手机号!'))
    }
    if (!Number.isInteger(value - 0)) {
      return Promise.reject(new Error('请输入正确格式的手机号!'))
    }
    const phoneResult = await user.checkPhone({ phone: value })
    if (phoneResult) {
      return Promise.resolve()
    } else {
      return Promise.reject(new Error('手机号尚未注册'))
    }
  }

  // 处理注册
  const onFinish = async({ phone }) => {
    checkPhoneValue(phone).then(()=>{
      forgetFormRef.current.open(phone)
      handleModalVisible(false)
    }).catch((err) => {
      message.error(err.message || '手机号出错')
    })
  }

  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        title='用户找回密码'
        visible={findModalVisible}
        onCancel={() => handleModalVisible(false)}
        footer={null}
        width={428}
      >
        <Form
          onFinish={onFinish}
          name='normal_find'
        >
          <Form.Item
            name='phone'
            label='手机号'
            rules={[{ required: true, message: '手机号不能为空' }]}
            getValueFromEvent={(e) => e.target.value.trim()}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <div className={styles['btns']}>
              <Space>
                <Button onClick={() => handleModalVisible(false)} >
             取消
                </Button>
                <Button type='primary' htmlType='submit' >
              下一步
                </Button>
              </Space>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <ForgetForm onRef={forgetFormRef} />
    </Fragment>
  )
}

export default ForgetPassword
